// extracted by mini-css-extract-plugin
export default {"breadcrumb":"src-pages-Order-ShoppingCartTemplate-List-css-module__breadcrumb--uVSMe"};